import { Link } from "react-router-dom";

const entries = [
  {
    label: "电影",
    desc: "院线大片 · 经典佳作",
    icon: "ri-film-line",
    to: "/category/movie",
    tone: "bg-primary-100 text-primary-700",
  },
  {
    label: "电视剧",
    desc: "热播剧集 · 口碑佳作",
    icon: "ri-tv-2-line",
    to: "/category/tv",
    tone: "bg-accent-100 text-accent-700",
  },
  {
    label: "综艺",
    desc: "真人秀 · 音乐 · 美食",
    icon: "ri-mic-line",
    to: "/category/variety",
    tone: "bg-secondary-100 text-secondary-700",
  },
  {
    label: "最新上线",
    desc: "刚刚更新 · 抢先看",
    icon: "ri-flashlight-line",
    to: "/category/movie?sort=latest",
    tone: "bg-primary-100 text-primary-700",
  },
];

export default function CategoryEntries() {
  return (
    <section className="mx-auto w-full max-w-[1440px] px-4 md:px-8">
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-5">
        {entries.map((item, i) => (
          <Link
            key={item.label}
            to={item.to}
            className="animate-fade-up group flex cursor-pointer items-center gap-3 rounded-lg border border-background-200/80 bg-background-50 p-4 transition-colors hover:border-primary-300 md:gap-4 md:p-5"
            style={{ animationDelay: `${i * 80}ms` }}
          >
            <span
              className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-lg md:h-14 md:w-14 ${item.tone}`}
            >
              <i className={`${item.icon} text-2xl md:text-3xl`}></i>
            </span>
            <div className="min-w-0">
              <h3 className="whitespace-nowrap text-sm font-bold text-foreground-950 md:text-base">
                {item.label}
              </h3>
              <p className="mt-0.5 hidden truncate text-xs text-foreground-500 sm:block">
                {item.desc}
              </p>
            </div>
            <i className="ri-arrow-right-line ml-auto hidden text-foreground-400 transition-transform group-hover:translate-x-1 md:block"></i>
          </Link>
        ))}
      </div>
    </section>
  );
}